'use client'

import { useState } from 'react'
import { HeaderSection } from '@/components/shared/header-section'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import PagesTree from './components/PagesTree'
import QuickCreatePageDialog from './components/QuickCreatePageDialog'
import { PageContent } from '@/components/shared/page-content'

export default function Pages() {
  const [searchTerm, setSearchTerm] = useState('')
  const [createOpen, setCreateOpen] = useState(false)

  return (
    <PageContent>
      <div className="flex justify-between items-center">
        <HeaderSection title="Pages" />
        <Button onClick={() => setCreateOpen(true)}>Create New +</Button>
      </div>

      <div className="flex items-center">
        <Input
          placeholder="Filter pages..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="max-w-sm"
        />
      </div>

      <PagesTree searchTerm={searchTerm} />

      <p className="text-sm text-muted-foreground mt-2">
        The{' '}
        <code className="text-xs bg-muted px-1 py-0.5 rounded">
          home-page
        </code>{' '}
        and <code className="text-xs bg-muted px-1 py-0.5 rounded">login</code>{' '}
        codes are reserved — pages with these codes supply the hero image and
        title for the storefront home page and the login screen.
      </p>

      <QuickCreatePageDialog open={createOpen} onOpenChange={setCreateOpen} />
    </PageContent>
  )
}
